export enum UserAction {
  none = 0,
  viewing = 1,
  editing = 2,
}
